<template>
	<div class="chat-helper-so-container">
		<div class="chat-helper-so-search">
			<input type="date" placeholder="进粉开始时间" style="margin-left: 0;width: 130px;" v-model="requestParams.start_time">
			<input type="date" placeholder="进粉截至时间" style="width: 130px;" v-model="requestParams.end_time">
			<input type="text" placeholder="粉丝昵称" v-model="requestParams.wx_name">
			<input type="text" placeholder="粉丝标签" v-model="requestParams.tag">
			<select name="" id="" v-model="requestParams.custom_id">
				<option value="">--选择客服--</option>
				<option :value="custom.id" v-for="custom in customList">{{custom.wx_name}}-{{custom.identity}}</option>
			</select>
			<select name="" id="" v-model="requestParams.fans_type">
				<option value="">--选择粉丝类型--</option>
				<option :value="fansType" v-for="fansType in fansTypes">{{fansType}}</option>
			</select>
			<button @click="search">搜索</button>
		</div>
		<div class="chat-helper-so-box">
			<div class="chat-helper-so-fans" style="border-right: 1px solid #dedede;">
				<div class="chat-helper-sof-title">
					<span>好友列表<!-- （<i class="chat-helper-sof-num">10921</i>） --></span>
					<span class="chat-helper-sof-s chat-helper-sof-select chat-helper-sof-select-active" title="全部选中"  @click="selectAllFans()"></span>
				</div>
				<div class="chat-helper-sof-label">
					<ul>
						<li class="chat-helper-sof-select" :class="{'chat-helper-sof-select-active' : pageAllSelectFlag}" @click="selectPageFans()"></li>
						<li>昵称</li>
						<li>备注</li>
						<li>标签</li>
					</ul>
				</div>
				<div class="chat-helper-sof-items">
					<ul v-for="fans in fansList" @click="selectFans(fans)">
						<li class="chat-helper-sof-select" :class="{'chat-helper-sof-select-active' : selectWxids.indexOf(fans.open_id+'__'+fans.id) !== -1}"></li>
						<li>{{fans.wx_name}}</li>
						<li>{{fans.con_remark}}</li>
						<li :title="fans.tags">{{fans.tags}}</li>
					</ul>
				</div>
				<div class="chat-helper-sof-page">
					<page-component 
						:dataApi="dataApiFunction" 
						:requestParams="requestParams" 
						@page-call="pageCall($event)"
						ref="chatHelperSoP1"
						key="chat-helper-so-p1"></page-component>
				</div>
			</div>
			<div class="chat-helper-so-fans">
				<div class="chat-helper-sof-title">
					<span>已选好友列表（<i class="chat-helper-sof-s-num">{{selectWxids.length}}</i>）</span>
					<span class="chat-helper-sof-s chat-helper-sof-select" title="全部取消" @click="delAllFans"></span>
				</div>
				<div class="chat-helper-sof-label">
					<ul>
						<li class="chat-helper-sof-select" @click="delPageFans"></li>
						<li>昵称</li>
						<li>备注</li>
						<li>标签</li>
					</ul>
				</div>
				<div class="chat-helper-sof-items" style="bottom: 0;">
					<ul v-for="fans in fansSList">
						<li class="chat-helper-sof-select" @click="delFans(fans)"></li>
						<li>{{fans.wx_name}}</li>
						<li>{{fans.con_remark}}</li>
						<li>{{fans.tags}}</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../../components/PageComponent.vue'
	import {getFansListWithPage} from '../../../network/local/friend.js'
	import {getCustomList} from '../../../network/local/custom.js'
	
	export default{
		name:'ChatHelperStepOne',
		components:{
			PageComponent
		},
		data(){
			return{
				dataApiFunction:getFansListWithPage,
				requestParams:{
					wx_name: '',
					custom_id:'',
					fans_type:'',
					tag:'',
					start_time:'',
					end_time:'',
					prePage: 16
				},
				fansList:[],
				fansSList:{},
				selectWxids:[],
				pageAllSelectFlag: false,
				customList: [],
				fansTypes:['W','L','C','S']
			}
		},
		methods:{
			// 初始化部分数据
			init(){
				this.fansSList = {}
				this.selectWxids = []
			},
			// 粉丝数据列表回调
			pageCall(data){
				this.fansList = data
				this.pageAllSelectFlag = false
			},
			
			// 左侧粉丝选择
			selectFans(fans){
				let fansWxid = fans.open_id+'__'+fans.id
				let index = this.selectWxids.indexOf(fansWxid)
				if(index === -1){
					this.selectWxids.push(fansWxid)
					this.$set(this.fansSList,fansWxid,fans)
				}else{
					this.selectWxids.splice(index,1)
					this.$delete(this.fansSList,fansWxid)
				}	
				this.emitFans()
			},
			
			// 左侧粉丝选择-选择当前分页所有或者取消
			selectPageFans(){
				this.pageAllSelectFlag = !this.pageAllSelectFlag
				// 当前页全部选中
				if(this.pageAllSelectFlag){
					for (let i = 0; i < this.fansList.length; i++) {
						let fansWxid = this.fansList[i].open_id+'__'+this.fansList[i].id
						let index = this.selectWxids.indexOf(fansWxid)
						if(index === -1){
							this.selectWxids.push(fansWxid)
							this.$set(this.fansSList,fansWxid,this.fansList[i])
						}
					}
				}
				// 当前页的全部取消
				else{
					for (let i = 0; i < this.fansList.length; i++) {
						let fansWxid = this.fansList[i].open_id+'__'+this.fansList[i].id
						let index = this.selectWxids.indexOf(fansWxid)
						if(index !== -1){
							this.selectWxids.splice(index,1)
							this.$delete(this.fansSList,fansWxid)
						}
					}
				}
				this.emitFans()
			},
			
			// 左侧粉丝选择-选择当前搜索条件下所有的粉丝
			selectAllFans(){
				getFansListWithPage(this.requestParams,data=>{
					if(data.total == 0){
						return
					}
					// 初始化已选数据，避免重复
					this.selectWxids = []
					this.fansSList = {}
					this.pageAllSelectFlag = true
					// 循环添加数据
					let allFans = data.data
					for (let i = 0; i < allFans.length; i++) {
						let fansWxid = allFans[i].open_id+'__'+allFans[i].id
						this.selectWxids.push(fansWxid)
						this.$set(this.fansSList,fansWxid,allFans[i])
					}
					this.emitFans()
				},true)
			},
			
			// 右侧已选页面-删除单个粉丝
			delFans(fans){
				let fansWxid = fans.open_id+'__'+fans.id
				let index = this.selectWxids.indexOf(fansWxid)
				if(index !== -1){
					this.selectWxids.splice(index,1)
					this.$delete(this.fansSList,fansWxid)
				}
				this.emitFans()
			},
			
			// 右侧已选页面-删除当前页面的所有粉丝
			delPageFans(){
				let selectWxids = JSON.parse(JSON.stringify(this.selectWxids))
				for (let i = 0; i < selectWxids.length; i++) {
					let index = this.selectWxids.indexOf(selectWxids[i])
					if(index !== -1){
						this.selectWxids.splice(index,1)
						this.$delete(this.fansSList, selectWxids[i])
					}
				}
				this.pageAllSelectFlag = false
				this.emitFans()
			},
			
			// 右侧已选页面-删除页面的所有粉丝
			delAllFans(){
				this.pageAllSelectFlag = false
				this.selectWxids = []
				this.fansSList = {}
				this.emitFans()
			},
			
			// 搜索
			search(){
				this.$refs.chatHelperSoP1.initPage()
			},
			
			// 将粉丝对象转换为数组数据，传送给父级组件
			emitFans(){
				let data = []
				for(let i in this.fansSList){
					data.push(this.fansSList[i])
				}
				this.$emit('sender-fans-call',data)
			}
		},
		created() {
			// 获取客服列表
			getCustomList(data=>{
				this.customList = data
			})
		}
	}
</script>

<style>
	.chat-helper-so-container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.chat-helper-so-container .chat-helper-so-search{
		height: 30px;
		padding: 0 10px;
		margin-bottom: 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #666666;
	}
	.chat-helper-so-search>*{
		display: block;
	}
	.chat-helper-so-search input,.chat-helper-so-search select{
		width: 120px;
		height: 28px;
		border: 1px solid #dedede;
		margin: 0 2px;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
	}
	.chat-helper-so-search select{
		width: 140px !important;
	}
	.chat-helper-so-search button{
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		margin-left: 2px;
		color: #FFFFFF;
		background-color: #42B983;
		border-radius: 2px;
		cursor: pointer;
	}
	.chat-helper-so-box{
		border: 1px solid #dedede;
		position: absolute;
		top: 40px;
		left: 10px;
		right: 10px;
		bottom: 0;
		border-radius: 2px;
		display: flex;
		justify-content: flex-start;
	}
	.chat-helper-so-box .chat-helper-so-fans{
		width: 50%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.chat-helper-so-fans .chat-helper-sof-title{
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #dedede;
	}
	.chat-helper-sof-title span{
		display: block;
	}
	.chat-helper-sof-title .chat-helper-sof-s{
		width: 30px;
	}
	.chat-helper-sof-num,.chat-helper-sof-s-num{
		font-style: normal;
		font-weight: bold;
	}
	.chat-helper-sof-num{
		color: #ff2411;
	}
	.chat-helper-sof-s-num{
		color: #42B983;
	}
	.chat-helper-so-fans .chat-helper-sof-label{
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		border-bottom: 1px solid #dedede;
	}
	.chat-helper-sof-label ul{
		display: flex;
		justify-content: space-between;
	}
	.chat-helper-sof-label ul li{
		display: block;
		height: 40px;
		overflow: hidden;
	}
	.chat-helper-sof-label ul li:nth-child(1){
		width: 30px;
		margin-right: 10px;
	}
	.chat-helper-sof-label ul li:nth-child(2){
		width: 150px;
	}
	.chat-helper-sof-label ul li:nth-child(3){
		width: 200px;
	}
	.chat-helper-sof-label ul li:nth-child(4){
		flex-grow: 1;
		width: 0;
	}
	.chat-helper-sof-label ul li input{
		vertical-align: middle;
		cursor: pointer;
	}
	.chat-helper-so-fans .chat-helper-sof-items{
		position: absolute;
		top: 82px;
		left: 0;
		right: 0;
		bottom: 46px;
		overflow-x: hidden;
		overflow-y: auto;
		color: #777777;
	}
	.chat-helper-sof-items ul{
		height: 36px;
		line-height: 36px;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		cursor: pointer;
		user-select: none;
	}
	.chat-helper-sof-items ul li{
		height: 36px;
		overflow: hidden;
	}
	.chat-helper-sof-items ul li:nth-child(1){
		width: 30px;
		margin-right: 10px;
	}
	.chat-helper-sof-items ul li:nth-child(2){
		width: 150px;
	}
	.chat-helper-sof-items ul li:nth-child(3){
		width: 200px;
	}
	.chat-helper-sof-items ul li:nth-child(4){
		flex-grow: 1;
		width: 0;
	}
	.chat-helper-sof-items ul li input{
		vertical-align: middle;
		cursor: pointer;
	}
	.chat-helper-sof-items ul:nth-child(even){
		background-color: #f3f3f3;
	}
	.chat-helper-so-fans .chat-helper-sof-page{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 10px;
		height: 26px;
		padding: 0 10px;
	}
	.chat-helper-sof-select{
		background-image: url(../../../assets/img/select-out.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 18px auto;
		cursor: pointer;
	}
	.chat-helper-sof-select-active{
		background-image: url(../../../assets/img/select-in.png) !important;
	}
</style>
